/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useCallback, useEffect, useState } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { formatSecondsToTextDuration } from '../../../utils/utils';
import { useExamDeadline, useMostRecentExamAttempt } from '../../exams';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useExpiredModalState } from '../examsStores';
import { useValidateExam } from '../examsQueries';
import UsageTracker from '../../../utils/UsageTracker';
import { useFullTrack } from '../../tracks';
import { jsx as _jsx } from "react/jsx-runtime";
const ONE_SECOND_IN_MS = 1000;
const ExamTimer = ({
  trackId,
  passive,
  language
}) => {
  const {
    showExpiredModal,
    setShowExpiredModal
  } = useExpiredModalState();
  const {
    examDeadline,
    examDeadlineLoading
  } = useExamDeadline(Number(trackId), language);
  const [remainingSeconds, setRemainingSeconds] = useState(examDeadline ? (examDeadline - Date.now()) / ONE_SECOND_IN_MS : 0);
  const {
    track
  } = useFullTrack(trackId, language);
  const {
    mostRecentExamAttempt
  } = useMostRecentExamAttempt(Number(trackId), language);
  const [validateExam] = useValidateExam();
  const handleTimeExpired = useCallback(() => {
    if (mostRecentExamAttempt && !mostRecentExamAttempt.finished && !passive) {
      UsageTracker.track('examInteraction', {
        action: 'time-expired',
        trigger: 'timeout',
        examId: track && track.exam.id,
        examLength: mostRecentExamAttempt.questions.length,
        trackId: trackId && trackId.toString(),
        trackName: track && track.name,
        examAttemptId: mostRecentExamAttempt.id && mostRecentExamAttempt.id.toString()
      });
      setShowExpiredModal(true);
      return validateExam(Number(trackId), mostRecentExamAttempt.id).then(() => {
        UsageTracker.track('examInteraction', {
          action: 'completed',
          examId: track && track.exam.id,
          examLength: mostRecentExamAttempt.questions.length,
          trackId: trackId && trackId.toString(),
          trackName: track && track.name,
          examAttemptId: mostRecentExamAttempt.id && mostRecentExamAttempt.id.toString()
        });
      });
    }
    return null;
  }, [mostRecentExamAttempt, passive, setShowExpiredModal, track, trackId, validateExam]);
  useEffect(() => {
    if (showExpiredModal || examDeadline === null) return () => {};
    const interval = setInterval(() => {
      const secondsLeft = (examDeadline - Date.now()) / ONE_SECOND_IN_MS;
      if (secondsLeft <= 0) {
        clearInterval(interval);
        handleTimeExpired();
      } else {
        setRemainingSeconds(secondsLeft);
      }
    }, ONE_SECOND_IN_MS);
    return () => {
      clearInterval(interval);
    };
  }, [examDeadline, showExpiredModal, handleTimeExpired]);
  if (examDeadlineLoading) return /*#__PURE__*/_jsx(UILoadingSpinner, {});
  return /*#__PURE__*/_jsx("div", {
    className: "quiz-timer",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "learningCenter.exams.examQuestion.timeRemaining",
      options: {
        timeRemaining: formatSecondsToTextDuration(remainingSeconds)
      }
    })
  });
};
export default ExamTimer;